import { render, staticRenderFns } from "./Coordinations.vue?vue&type=template&id=8ed5b856&scoped=true"
import script from "./Coordinations.vue?vue&type=script&lang=js"
export * from "./Coordinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed5b856",
  null
  
)

export default component.exports